import {Home} from 'site-v2/home'
export default Home
